import { InvoiceGenericItem } from './invoice-generic-item';
import { InvoiceProductItem } from './invoice-product-item';
import { InvoiceTextItem } from './invoice-text-item';

export type InvoiceItem = InvoiceProductItem | InvoiceTextItem | InvoiceGenericItem;

export const isInvoiceProductItem = (invoiceItem: InvoiceItem): invoiceItem is InvoiceProductItem => {
    return (invoiceItem as InvoiceProductItem).name !== undefined;
};

export const isInvoiceGenericItem = (invoiceItem: InvoiceItem): invoiceItem is InvoiceGenericItem => {
    return (invoiceItem as InvoiceGenericItem).type !== undefined;
};

export const isInvoiceTextItem = (invoiceItem: InvoiceItem): invoiceItem is InvoiceTextItem => {
    return !isInvoiceGenericItem(invoiceItem) && !isInvoiceProductItem(invoiceItem);
};
